import React,{useState,useEffect} from 'react'
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { app } from '../Firebase/Firebaseapp';
import { useDispatch } from 'react-redux';
import { GetSearchData } from '../Redux/Slice/DataSlice';
import { useNavigate } from 'react-router-dom';



const fireStorage = getStorage(app);
const CategoryCard = ({x}) => {
  const Dispatch =useDispatch()
  const Navigate=useNavigate()
 const [GetImage, setGetImage] = useState("");
 const [searchData] = useState({
  carName:"",
  Category:x.Categories,
  Brand:"",
  Price:""   
})

    
  const getBrandImg =(path) => {
    return  getDownloadURL(ref(fireStorage, path))
  }

  useEffect(() => {
    getBrandImg(x.CategoryLogo).then((url) => setGetImage(url))
      console.log("I  am Addbrand")
 
  }, [])

  const getCategoryCars=()=>{
    Dispatch(GetSearchData(searchData))
    Navigate('/cars')
  }

  return (
 <div class="mt-6 h-65 sm:w-[28%] w-[90%] mx-5 relative " key={x.id} onClick={getCategoryCars}>

 <div className="h-[100%] w-[100%] relative rounded-lg ">
 <img src={GetImage  } alt="" className=' rounded-lg   h-64 w-[100%]' />
 </div>
         <article className=" absolute top-0 h-64 w-[100%]   group rounded-lg overflow-hidden shadow-lg hover:shadow-2xl  transition duration-300 ease-in-out " >
                <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:opacity-75 transition duration-300 ease-in-out"></div>
                <div className="relative w-[100%]  h-64  px-4 sm:px-6 lg:px-4 flex justify-center items-center">
                    <h3 className="text-center">
                        <div className="text-white text-2xl font-bold text-center" >
                            <span className="absolute inset-0"></span>
                            Top 10  {x.Categories} cars 2023
                        </div>
                    </h3>
                </div>
            </article>
            
        </div>

 
  )
}

export default CategoryCard